'use strict';

var novicell = novicell || {};

novicell.productPagePrices =
    novicell.productPagePrices ||
    (function() {
        var inputLicenses = null;
        var fieldsLicenseTypes = null;
        var durationAmountSelectField = null;
        var amountHardware = null;
        var fieldsDurationType = null;
        var fieldQuantity = null;
        var fieldVariantID = null;
        var productType = null;
        var priceBarPriceItem = null;
        var submitBtn = null;
        var normalFieldQuantity = null;
        var changingDaysYearsOnSoftware = false; //used to prevent visible price on updating in 2 steps
        var keepPromises;
        var lastClick = { selectId2: 0, EcomOrderLineFieldInput_Licenses: 0 };
        var timestamps = {};
        var doNotSearchBeforeMilisecondsAmount = 200;
        function init() {
            setOuterScopeVars();
            if (productType == 'software') {
                initMinimumAmountPeriod();
                setMinimumAmountPeriod();
                initSoftwareQuantityCalculation();
            } else {
                setAmountHardwareListeners();
                initNormalPriceCalculation();
            }
        }
        function initMinimumAmountPeriod() {
            var daysOrWeeksFields = document.querySelectorAll('.daysOrWeeks__Year, .daysOrWeeks__Day');

            for (var i = 0; i < daysOrWeeksFields.length; i++) {
                daysOrWeeksFields[i].addEventListener('click', setMinimumAmountPeriod, false);
            }
        }
        function setMinimumAmountPeriod() {
            changingDaysYearsOnSoftware = true;
        
            var yearField = document.querySelector('.daysOrWeeks__Year');
            var daysField = document.querySelector('.daysOrWeeks__Day');
        
            if (yearField && daysField) {
                if (yearField.checked) {
                    durationAmountSelectField.removeAttribute('min');
                    durationAmountSelectField.value = 1;
                    sessionStorage.setItem("yearField", "checked");
                    sessionStorage.removeItem("dayField");
                } else if (daysField.checked) {
                    var minvalue = durationAmountSelectField.getAttribute('data-min');
                    durationAmountSelectField.setAttribute('min', minvalue);
                    durationAmountSelectField.value = minvalue;
                    sessionStorage.setItem("dayField", "checked");
                    sessionStorage.removeItem("yearField");
                } else {
                    console.log('Software product: neither days nor years are selected');
                }
            }
            setSoftwareHiddenValues();
            changingDaysYearsOnSoftware = false;
        }

        // Restore checkbox states on page load based on session storage
        document.addEventListener('DOMContentLoaded', function() {
            var yearField = document.querySelector('.daysOrWeeks__Year');
            var daysField = document.querySelector('.daysOrWeeks__Day');

            if (sessionStorage.getItem("yearField") === "checked" && yearField) {
                yearField.checked = true;
            } else if (sessionStorage.getItem("dayField") === "checked" && daysField) {
                daysField.checked = true;
            }

            setMinimumAmountPeriod(); // Call this to apply the correct state on load
        });

        function initNormalPriceCalculation() {
            normalPriceCalculation();
            if (normalFieldQuantity != null) {
                normalFieldQuantity.addEventListener(
                    'change',
                    function() {
                        if(parseInt(this.dataset.stock) < parseInt(this.value) && parseInt(this.dataset.stock) > 0) {
                            document.querySelector(".js-stock-limit").classList.remove("hidden");
                        } else {
                            document.querySelector(".js-stock-limit").classList.add("hidden");
                        }
                        debounce(this, normalPriceCalculation);
                    },
                    false
                );
                normalFieldQuantity.addEventListener(
                    'keyup',
                    function() {
                        if(parseInt(this.dataset.stock) < parseInt(this.value) && parseInt(this.dataset.stock) > 0) {
                            document.querySelector(".js-stock-limit").classList.remove("hidden");
                        } else {
                            document.querySelector(".js-stock-limit").classList.add("hidden");
                        }
                        debounce(this, normalPriceCalculation);
                    },
                    false
                );
                normalFieldQuantity.addEventListener(
                    'paste',
                    function() {
                        if(parseInt(this.dataset.stock) < parseInt(this.value) && parseInt(this.dataset.stock) > 0) {
                            document.querySelector(".js-stock-limit").classList.remove("hidden");
                        } else {
                            document.querySelector(".js-stock-limit").classList.add("hidden");
                        }
                        debounce(this, normalPriceCalculation);
                    },
                    false
                );
            }
        }
        function filterInput(input) {
            // Remove any non-numeric characters
            input.value = input.value.replace(/[^0-9]/g, '');
        
            // Prevent the value from starting with '0'
            if (input.value.startsWith('0')) {
                input.value = input.value.replace(/^0+/, '');
            }
        }
        function normalPriceCalculation(thisElemId) {
            clearMyTimeout(thisElemId);
            var productidField = document.querySelector('#oPriceBarHardwareProductID, #ProductID');
            if (productidField == null) {
                return;
            }
            var productid = productidField.value;
            var normalQuantity = normalFieldQuantity.value;
            var priceBarNormalPriceItem = document.querySelector('.o-priceBar .m-price__price');
            var priceVatTextElem = document.querySelector('.o-priceBar .m-price__vat');
            if (productid != null && normalQuantity != null && productid != '' && normalQuantity != '' && priceBarNormalPriceItem != null) {
                var url = '/system/ajax/ajax-price?productid=' + productid + '&quantity=' + normalQuantity;
                priceBarNormalPriceItem.innerHTML = '<div class="a-spinner"></div>';
                get(url).then(
                    function(response) {
                        priceBarNormalPriceItem.innerHTML = response;
                    },
                    function(error) {
                        console.error('novicell.normalPriceCalculation:', error);
                    }
                );
                submitBtn.removeAttribute('disabled');
                priceVatTextElem.removeAttribute('style');
            } else {
                //var priceField = document.getElementById('o-priceBar__item--price-software');
                priceBarNormalPriceItem.innerHTML = '';
                submitBtn.setAttribute('disabled', 'true');
                priceVatTextElem.style.display = 'none';
                //console.log('Error: when it\'s not software this is not shown');
            }
        }
        function setOuterScopeVars() {
            inputLicenses = document.getElementById('EcomOrderLineFieldInput_Licenses');
            fieldsLicenseTypes = document.querySelectorAll('input[name="subscriptionOrPermanent"]');
            durationAmountSelectField = document.getElementById('selectId2');
            amountHardware = document.getElementById('amountHardware');
            fieldsDurationType = document.querySelectorAll('input[name="daysOrWeeks"]');
            fieldQuantity = document.getElementById('quantity');
            normalFieldQuantity = document.querySelector('input[name="quantity"]');
            fieldVariantID = document.getElementById('VariantID');
            priceBarPriceItem = document.getElementById('o-priceBar__item--price-software');
            submitBtn = document.querySelector('.a-button--green.o-priceBar__button[type=submit]');

            var priceBar = document.querySelector('.o-priceBar');
            if (priceBar != null) {
                if (priceBar.classList.contains('o-priceBar--software')) {
                    productType = 'software';
                } else if (priceBar.classList.contains('o-priceBar--hardware')) {
                    productType = 'hardware';
                } else if (priceBar.classList.contains('o-priceBar--training')) {
                    productType = 'training';
                } else {
                    console.log('This is a product that is not set to type hardware, software or training');
                }
            }
        }
        function setAmountHardwareListeners() {
            if (amountHardware != null) {
                amountHardware.addEventListener(
                    'change',
                    function() {
                        filterInput(this);
                    },
                    false
                );
                amountHardware.addEventListener(
                    'keyup',
                    function() {
                        filterInput(this);
                    },
                    false
                );
                amountHardware.addEventListener(
                    'paste',
                    function() {
                        filterInput(this);
                    },
                    false
                );
            }
        }
        function initSoftwareQuantityCalculation() {
            var priceBar = document.querySelector('.o-priceBar');
            if (priceBar != null && fieldQuantity != null && fieldVariantID != null) {
                initChangeLicenseType();
                initSoftwareHiddenValues();
            }
        }
        function initSoftwareHiddenValues() {
            setSoftwareHiddenValues();

            if (inputLicenses != null && !changingDaysYearsOnSoftware) {

                inputLicenses.addEventListener(
                    'change',
                    function() {
                        debounce(this, setSoftwareHiddenValues);
                    },
                    false
                );
                inputLicenses.addEventListener(
                    'keydown',
                    function (k) {
                        if (k.code.includes("Enter")) {
                            k.preventDefault();
                            k.stopPropagation();
                            k.returnValue = false;
                            return false;
                        }
                        debounce(this, setSoftwareHiddenValues);
                    },
                    false
                );
                inputLicenses.addEventListener(
                    'keyup',
                    function (k) {

                        debounce(this, setSoftwareHiddenValues);
                    },
                    false
                );
                inputLicenses.addEventListener(
                    'paste',
                    function() {
                        debounce(this, setSoftwareHiddenValues);
                    },
                    false
                );
            }
            if (fieldsLicenseTypes != null) {
                for (var i = 0; i < fieldsLicenseTypes.length; i++) {
                    fieldsLicenseTypes[i].addEventListener(
                        'click',
                        function() {
                            debounce(this, setSoftwareHiddenValues);
                        },
                        false
                    );
                }
            }
            if (fieldsDurationType != null) {
                for (var j = 0; j < fieldsDurationType.length; j++) {
                    fieldsDurationType[j].addEventListener(
                        'click',
                        function() {
                            debounce(this, setSoftwareHiddenValues);
                        },
                        false
                    );
                }
            }
            if (durationAmountSelectField != null) {
                durationAmountSelectField.addEventListener(
                    'change',
                    function() {
                        filterInput(this);
                        debounce(this, setSoftwareHiddenValues);
                    },
                    false
                );
                durationAmountSelectField.addEventListener(
                    'keydown',
                    function (k) {
                        if (k.code.includes("Enter")) {
                            k.preventDefault();
                            k.stopPropagation();
                            k.returnValue = false;
                            return false;
                        }
                        debounce(this, setSoftwareHiddenValues);
                    },
                    false
                );
                durationAmountSelectField.addEventListener(
                    'keyup',
                    function() {
                        filterInput(this);
                        debounce(this, setSoftwareHiddenValues);
                    },
                    false
                );
                durationAmountSelectField.addEventListener(
                    'paste',
                    function() {
                        filterInput(this);
                        debounce(this, setSoftwareHiddenValues);
                    },
                    false
                );
            }
        }

        function debounce(elem, functionName) {
            if (lastClick[elem.id] == 0) {
                lastClick[elem.id] = Date.now();
            }
            var rightNow = Date.now();
            var milisecondsSinceLastType = rightNow - lastClick[elem.id];
            if (milisecondsSinceLastType <= doNotSearchBeforeMilisecondsAmount) {
                clearMyTimeout(elem.id);
            }
            lastClick[elem.id] = rightNow;
            if (timestamps[elem.id] == undefined) {
                timestamps[elem.id] = setTimeout(functionName, doNotSearchBeforeMilisecondsAmount, elem.id);
            }
        }
        function clearMyTimeout(elemId) {
            if (timestamps[elemId] != undefined) {
                clearTimeout(timestamps[elemId]);
                delete timestamps[elemId];
            }
        }
        function initChangeLicenseType() {
            if (fieldsLicenseTypes.length) {
                for (var i = 0; i < fieldsLicenseTypes.length; i++) {
                    fieldsLicenseTypes[i].addEventListener('click', hideShowLicenseDuration, false);
                    if (fieldsLicenseTypes[i].checked) {
                        hideShowLicenseDuration(fieldsLicenseTypes[i]);
                    }
                }
            }
        }
    function hideShowLicenseDuration(elem) {
        durationAmountSelectField = document.getElementById('selectId2');
            if (elem.name == undefined) {
                elem = this;
            }
            if (elem.checked) {
                var durationFields = null;
                var permanentDeliveryTime = null;
                var subscriptionDeliveryTime = null;
                var priceBar = novicell.helpers.closestByClass(elem, 'o-priceBar');
                if (priceBar != null) {
                    durationFields = priceBar.querySelector('.o-priceBar__item--extraStuff');
                    permanentDeliveryTime = priceBar.querySelector('#permanent-delivery-time');
                    subscriptionDeliveryTime = priceBar.querySelector('#subscription-delivery-time');
                }

                if (durationFields != null) {
                    if (elem.id == 'subscriptionOrPermanent--permanent') {
                        durationFields.classList.add('o-priceBar__item--extraStuffHidden');
                        durationAmountSelectField.value = 1;
                        durationAmountSelectField.removeAttribute('min');
                        if (permanentDeliveryTime) {
                            permanentDeliveryTime.classList.remove('hidden');
                        }
                        if (subscriptionDeliveryTime) {
                            subscriptionDeliveryTime.classList.add('hidden');
                        }
                    } else if (elem.id == 'subscriptionOrPermanent--subscription') {
                        durationFields.classList.remove('o-priceBar__item--extraStuffHidden');
                        if(!durationAmountSelectField.hasAttribute('min')) {
                            setMinimumAmountPeriod();
                        }
                        if (permanentDeliveryTime) {
                            permanentDeliveryTime.classList.add('hidden');
                        }
                        if (subscriptionDeliveryTime) {
                            subscriptionDeliveryTime.classList.remove('hidden');
                        }
                    } else {
                        console.log('Error: not permanent, nor subscription');
                    }
                }
            } else {
                console.log('Error: radio button clicked but not checked');
            }
        }
        function get(url) {
            // Return a new promise.
            return new Promise(function(resolve, reject) {
                // Do the usual XHR stuff
                var req = new XMLHttpRequest();
                req.open('GET', url);

                req.onload = function() {
                    if (req.status >= 200 && req.status < 400) {
                        // Success!!
                        resolve(req.response);
                    } else {
                        // Error!!
                        reject(Error(req.statusText));
                    }
                };

                // Handle network errors
                req.onerror = function() {
                    reject(Error('Network Error'));
                };

                // Make the request
                req.send();
                if (keepPromises) {
                    //we want the last request only, so right price according to amount is shown
                    keepPromises.abort();
                }
                keepPromises = req;
            });
        }
        function setSoftwareHiddenValues(thisElemId) {
            clearMyTimeout(thisElemId);
            if (inputLicenses != null) {
                //if extrastuff is hidden it's permanent license
                var extraStuffHidden = document.querySelector('.o-priceBar__item--extraStuffHidden');
                var extraStuff = document.querySelector('.o-priceBar__item--extraStuff');
                var variantID = 0;
                var licenses = 1;
                var quantity = 1;
                var productid = null;
                if (extraStuffHidden != null || extraStuff == null) {
                    fieldVariantID.value = document.getElementById('subscriptionOrPermanent--permanent').value;
                    variantID = fieldVariantID.value;
                    quantity = inputLicenses.value;
                    fieldQuantity.value = quantity;
                } else {
                    if (durationAmountSelectField != null) {
                        var quantityValue = durationAmountSelectField.value * inputLicenses.value;
                        licenses = inputLicenses.value;
                        fieldQuantity.value = quantityValue;
                        quantity = durationAmountSelectField.value;
                        if (fieldsDurationType != null) {
                            for (var i = 0; i < fieldsDurationType.length; i++) {
                                if (fieldsDurationType[i].checked) {
                                    fieldVariantID.value = fieldsDurationType[i].id;
                                    variantID = fieldVariantID.value;
                                }
                            }
                        }
                    }
                }
                var productIdField = document.getElementById('softwareProductId');
                if (productIdField != null) {
                    productid = productIdField.value;
                }
                if (
                    productid != null &&
                    variantID != null &&
                    quantity != null &&
                    licenses != null &&
                    productid != '' /*&& variantID != ""*/ &&
                    quantity != '' &&
                    licenses != '' &&
                    priceBarPriceItem != null
                ) {
                    var addToMyEivaLink = document.getElementById("add-to-my-eiva-link");
                    if (addToMyEivaLink) {
                        addToMyEivaLink.setAttribute("data-variant-id", variantID);
                        if (extraStuffHidden != null || extraStuff == null) {
                            addToMyEivaLink.setAttribute("data-license-amount", quantity);
                            addToMyEivaLink.setAttribute("data-subscription-duration", 1);
                        } else {
                            addToMyEivaLink.setAttribute("data-license-amount", licenses);
                            addToMyEivaLink.setAttribute("data-subscription-duration", quantity);
                        }
                    }
                        
                    var url =
                        '/system/ajax/software-price?productid=' +
                        productid +
                        '&VariantID=' +
                        variantID +
                        '&quantity=' +
                        quantity +
                        '&licenses=' +
                        licenses;
                    //console.log(url);
                    priceBarPriceItem.innerHTML = '<div class="a-spinner"></div>';
                    get(url).then(
                        function(response) {
                            priceBarPriceItem.innerHTML = response;
                        },
                        function(error) {
                            console.error('novicell.setSoftwareHiddenValues:', error);
                        }
                    );
                    submitBtn.removeAttribute('disabled');
                } else {
                    var priceField = document.getElementById('o-priceBar__item--price-software');
                    priceField.innerHTML = '';
                    submitBtn.setAttribute('disabled', 'true');
                    //console.log('Error: when it\'s not software this is not shown');
                }
            }
        }

        return {
            init: init,
            setSoftwareHiddenValues: setSoftwareHiddenValues
        };
    })();
